import EnumClass, { build } from '../EnumClass';
import data, { VocabTypeId, VocabTypeData } from './data';
import * as Translations from './translations';

export class VocabType extends EnumClass<VocabTypeId, VocabTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: VOCAB_TYPES,
  getById: getVocabTypeById,
  marshaller: VocabTypeMarshaller,
} = build<VocabTypeId, VocabTypeData, VocabType>('VocabTypeEnum', data, VocabType);
